import React from 'react';
import { Theme } from '../Theme';

export type FileViewerFile = {
    url: string;
    name: string;
    contentType?: string;
};

type FileViewerProps = {
    file: FileViewerFile;
    height?: string | number;
};

function getFileExtension(fileName: string): string {
    // Prefer extensions because Storage metadata is not always set for older uploads.
    return fileName.split('.').pop()?.toLowerCase() || '';
}

export function FileViewer(props: FileViewerProps) {
    const { file, height = 'calc(100vh - 280px)' } = props;
    const fileExtension = getFileExtension(file.name);
    const contentType = (file.contentType || '').toLowerCase();
    const isImage = contentType.startsWith('image/') ||
        ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
    const isPdf = contentType === 'application/pdf' || fileExtension === 'pdf';
    const isText = contentType.startsWith('text/') ||
        ['txt', 'csv', 'json', 'xml'].includes(fileExtension);

    if (isImage) {
        return (
            <div style={styles.imageContainer}>
                <img
                    src={file.url}
                    alt={file.name}
                    style={styles.image}
                />
            </div>
        );
    }

    if (isPdf || isText) {
        return (
            <div style={{ ...styles.iframeContainer, height }}>
                <iframe
                    src={file.url}
                    width='100%'
                    height='100%'
                    frameBorder='0'
                    title={file.name}
                />
            </div>
        );
    }

    return (
        <div style={styles.unsupportedContainer}>
            <p style={styles.unsupportedText}>Preview not available for this file type.</p>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    imageContainer: {
        padding: '20px',
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
    iframeContainer: {
        flexGrow: 1,
    },
    unsupportedContainer: {
        padding: '20px',
    },
    unsupportedText: {
        ...Theme.Fonts.body,
        color: Theme.Colours.text,
    },
};
